<div class="border rounded-4 p-3 bg-light-subtle">
  <div class="d-flex align-items-center justify-content-between">
    <!-- File Info -->
    <div class="d-flex align-items-center gap-3">
      <div
        class="bg-white border rounded-3 d-flex align-items-center justify-content-center"
        style="width: 52px; height: 52px"
      >
        <i
          [class]="
            builderService.getIcon('mir_file_copy').type == 'mir'
              ? 'material-icons-outlined'
              : 'material-icons'
          "
          class="text-danger"
          style="font-size: 28px"
        >
          {{ builderService.getIcon("mir_file_copy").id }}
        </i>
      </div>

      <div>
        <div class="fw-bold">{{ fileResorsce?.name }}</div>
        <small class="text-muted">{{
          formatFileSize(fileResorsce?.size)
        }}</small>
      </div>
    </div>

    <!-- Download Button -->
    <a
      [href]="fileResorsce?.url"
      download
      class="btn btn-outline-primary rounded-circle d-flex align-items-center justify-content-center"
      style="width: 42px; height: 42px"
    >
      <i
        [class]="
          builderService.getIcon('mir_download').type == 'mir'
            ? 'material-icons-outlined'
            : 'material-icons'
        "
      >
        {{ builderService.getIcon("mir_download").id }}
      </i>
    </a>
  </div>
</div>

<!-- <div
  class="border rounded p-3 d-flex align-items-center justify-content-between bg-light"
>
  <span class="fw-medium">Upload File</span>

  <div>
    <input
      type="file"
      #fileInput
      class="d-none"
      (change)="onFileSelected($event)"
    />

    <button type="button" class="btn btn-success px-4" (click)="fileInput.click()">
      Upload
    </button>
  </div>
</div> -->
